import React, { Component } from 'react';
import PropTypes from 'prop-types'

import trashIcon from '../../static/img/icon-trash.png'


class ResidenceItem extends Component {

	render() {
		let { t } = this.context

		let { address } = this.props.residence

		return (
			<div className="ResidenceItem">
				<div className="first-column">
					<div className="street">{address.streetName}, {address.streetNumber}{address.streetBox ? ", "+address.streetBox : ""}</div>
					<div className="zip-city">{address.zipCode} {address.city}
						{this.props.onEditClick &&
						<div className="edit" onClick={this.onEditClick}>(modifier)</div>
						}
					</div>
				</div>
				{this.props.onResidenceSelected &&
				<div className="second-column">
					<div className="use-residence"
						 onClick={this.onResidenceSelected}>{t('booking_flow_residence_selection_use_address')}</div>
				</div>
				}
				{this.props.onDeleteClick &&
				<div className="second-column">
					<div className="delete-residence"
						 onClick={this.onDeleteClick}><img src={trashIcon} alt="delete"/></div>
				</div>
				}
			</div>
		)
	}

	onResidenceSelected = () => {
		this.props.onResidenceSelected(this.props.residence)
	}

	onEditClick = () => {
		this.props.onEditClick(this.props.residence)
	}

	onDeleteClick = () => {
		this.props.onDeleteClick(this.props.residence)
	}
}

ResidenceItem.contextTypes = { t: PropTypes.func }
export default ResidenceItem


// WEBPACK FOOTER //
// ./src/components/shared/ResidenceItem.js